import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './Spacer.module.scss';
import classNames from 'classnames';
const Spacer = ({ x, y, large }) => {
    return (_jsx("div", { className: classNames(styles.spacer, { [styles.spacerY]: y, [styles.spacerX]: x, [styles.spacerLarge]: large }) }));
};
export default React.memo(Spacer);
